// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3zq_r","options":"AnswerScale_options__1Vtpe","selected":"AnswerScale_selected__3k12c"};